import { createSelector } from '@ngrx/store';

import { getCustomerState } from 'ish-core/store/customer/customer-store';

const getAccountNavigationFavoritesState = createSelector(getCustomerState, state => state.accountNavigationFavorites);

export const getAccountNavigationFavoriteIds = createSelector(
  getAccountNavigationFavoritesState,
  state => state.favoriteIds
);
